import Config from "src/Constants/Config";
import CustomCenterContent from "src/Pages/CustomCenterContent";
import setCurrentPage from "src/Utils/setCurrentPage";
import VideoMEF from "src/Component/VideoMEF";

const PageId = 10;

const DATA = () => {
  const customNextProps = {
    label: "Finish",
    type: "next",
    onClick: () => {
      setCurrentPage(2);
    },
  };

  return {
    showHeader: true,
    bgVideo: {
      video: `${Config.BASE_URL}/videos/mef.mp4`,
      poster: `${Config.BASE_URL}/images/bg_2.jpg`,
    },
    children: (
      <CustomCenterContent pageId={PageId} customNextProps={customNextProps}>
        <VideoMEF src={`${Config.BASE_URL}/videos/mef_2.mp4`} />
      </CustomCenterContent>
    ),
  };
};

export default DATA;
